import {Button, Modal} from "react-bootstrap";
import React from "react";

const ErrorServer = ({bodyText, handleClose, showModal}) =>{

    return (
        <>
            <Modal show={showModal} onHide={handleClose} backdrop='static' keyboard="False" size="lg" centered>
                <Modal.Header className={'justify-content-end py-0'}>
                    <Button variant={'link'} onClick={handleClose}>
                        chiudi x
                    </Button>
                </Modal.Header>
                <Modal.Body className={'mt-4 mb-5'}>
                    <h2 className={'title fw-bold'}>Errore Interno del Server</h2>
                </Modal.Body>
                <Modal.Footer className={'pt-0'}>
                    <Button variant={'primary'} className={'px-3'} onClick={handleClose}>
                        {bodyText}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ErrorServer;